import { ApiClient } from './client.js'
import { SHARED_TEAM_COLLECTIONS } from './resources.js'

const client = new ApiClient()

export default {
  retrieve (privateId) {
    return client.get(`${SHARED_TEAM_COLLECTIONS}${privateId}/`)
  }
}
